import React from 'react';
import gold from '../../../../../assets/icons/wellness-plan-gold-icon.svg';
import platinum from '../../../../../assets/icons/wellness-plan-platinum-icon.svg';
import diamond from '../../../../../assets/icons/wellness-plan-diamond-icon.svg';
import { WagWebAppUrl } from '../../../../../constants';
import { Typography } from '../../../../../components/Typography';
import { CheckIcon } from '../../../../../wag-react/next-components/icons';
import { UL } from '../../../../../wag-react/core-components/ul';
import { LI } from '../../../../../wag-react/core-components/li';
export enum WellnessPlanBenefits {
  VetChat = '24/7 live vet chat',
  PhysicalExam = 'Physical wellness exam',
  AnnualShotsBoosters = 'Annual shots / boosters',
  BloodDiagnosticTest = 'Blood / diagnostic testing',
  Deworming = 'Deworming',
  AnalGlandExpression = 'Anal gland expression',
  UrineFecalTest = 'Urine / fecal tests',
}
export const WELLNESS_PLAN_BENEFIT_DETAILS = {
  [WellnessPlanBenefits.VetChat]: <>
      <Typography>
        Connect with certified vets ASAP in the Wag! app.
      </Typography>
      <Typography>
        Plus, get a discount and no booking fees on all services, including walks, overnight care
        and training.
      </Typography>
    </>,
  [WellnessPlanBenefits.PhysicalExam]: <>
      <Typography>
        Your pet is covered for physical wellness exams which are a routine examination of your
        pet, and are normally done on an annual or twice annual basis. It’s a check-up
        to ensure your pet is healthy from head-to-toe and is essential in maintaining their
        wellbeing.
      </Typography>
      <Typography>
        There are no financial caps for pet wellness exams and we will pay 100% of whatever
        your vet charges you.
      </Typography>
    </>,
  [WellnessPlanBenefits.AnnualShotsBoosters]: <>
      <Typography>
        Routine vaccines recommended by your vet are essential to keeping your pet
        vaccinated against illnesses such as:
      </Typography>

      <UL>
        <LI>
          <Typography>
            Bordatella
          </Typography>
        </LI>
        <LI>
          <Typography>
            Leptospirosis
          </Typography>
        </LI>
        <LI>
          <Typography>
            Lyme Disease
          </Typography>
        </LI>
        <LI>
          <Typography>
            Influenza
          </Typography>
        </LI>
        <LI>
          <Typography>
            Rabies
          </Typography>
        </LI>
        <LI>
          <Typography>
            Distemper
          </Typography>
        </LI>
        <LI>
          <Typography>
            Hepatitis
          </Typography>
        </LI>
        <LI>
          <Typography>
            Coronavirus
          </Typography>
        </LI>
      </UL>

      <Typography>
        There are no financial caps for vaccines and boosters and we will pay 100%
        of whatever your vet charges you.
      </Typography>
    </>,
  [WellnessPlanBenefits.BloodDiagnosticTest]: <>
      <Typography>
        Routine bloodwork and diagnostic tests are carried out by your vet to check things
        such as:
      </Typography>

      <UL>
        <LI>
          <Typography>
            Complete Blood Counts
          </Typography>
        </LI>
        <LI>
          <Typography>
            Blood Panels
          </Typography>
        </LI>
        <LI>
          <Typography>
            Liver Panels
          </Typography>
        </LI>
        <LI>
          <Typography>
            Pancreas Panels
          </Typography>
        </LI>
        <LI>
          <Typography>
            Thyroid Panels
          </Typography>
        </LI>
        <LI>
          <Typography>
            Muscle & Bone Panels
          </Typography>
        </LI>
        <LI>
          <Typography>
            Heartworm Antigen Tests
          </Typography>
        </LI>
      </UL>

      <Typography>
        There are no financial caps for blood/diagnostic tests and we will pay 100% of
        whatever your vet charges you.
      </Typography>

      <Typography>
        Note: We do not cover senior health screens or anything else beyond the standard
        blood or diagnostic test.
      </Typography>
    </>,
  [WellnessPlanBenefits.Deworming]: <>
      <Typography>
        Routine deworming treats common intestinal parasites such as roundworm
        and hookworm.
      </Typography>

      <Typography>
        There are no financial caps for deworming tests and we will pay 100% of
        whatever your vet charges you.
      </Typography>
    </>,
  [WellnessPlanBenefits.UrineFecalTest]: <>
      <Typography>
        Urine / fecal tests help detect infections, dehydration, and disease.
      </Typography>

      <Typography>
        There are no financial caps for urine tests and we will pay 100% of whatever your
        vet charges you.
      </Typography>
    </>,
  [WellnessPlanBenefits.AnalGlandExpression]: <>
      <Typography>
        If your pet’s anal glands are not emptied properly during a bowel movement,
        secretions can build up, impacting the glands and potentially causing
        further issues.
      </Typography>

      <Typography>
        If left untreated they can become uncomfortable, itchy, and can rupture
        when not handled properly.
      </Typography>

      <Typography>
        There are no financial caps for anal gland expression and we will pay 100%
        of whatever your vet charges you.
      </Typography>
    </>
};
export enum WellnessPlanNames {
  Diamond = 'Diamond',
  Gold = 'Gold',
  Platinum = 'Platinum',
}
export const WELLNESS_PLANS = {
  [WellnessPlanNames.Gold]: {
    title: WellnessPlanNames.Gold,
    icon: gold,
    iconAlt: 'Wag! Wellness Gold Plan',
    description: 'Cover your pet’s basic vet visits to keep them healthy',
    benefits: {
      [WellnessPlanBenefits.VetChat]: '-',
      [WellnessPlanBenefits.PhysicalExam]: '1 / year',
      [WellnessPlanBenefits.AnnualShotsBoosters]: '3 / year',
      [WellnessPlanBenefits.BloodDiagnosticTest]: '1 / year',
      [WellnessPlanBenefits.Deworming]: '-',
      [WellnessPlanBenefits.UrineFecalTest]: '-',
      [WellnessPlanBenefits.AnalGlandExpression]: '-'
    },
    price: 14.95,
    buttonHref: WagWebAppUrl.WellnessGoldFlow
  },
  [WellnessPlanNames.Platinum]: {
    title: WellnessPlanNames.Platinum,
    icon: platinum,
    iconAlt: 'Wag! Wellness Platinum Plan',
    description: 'Everything included in the Gold Plan plus testing, deworming, and multiple shots per year',
    label: 'Most Popular',
    benefits: {
      [WellnessPlanBenefits.VetChat]: <CheckIcon width="24px" height="24px" color="wagGreen" />,
      [WellnessPlanBenefits.PhysicalExam]: '1 / year',
      [WellnessPlanBenefits.AnnualShotsBoosters]: '6 / year',
      [WellnessPlanBenefits.BloodDiagnosticTest]: '1 / year',
      [WellnessPlanBenefits.Deworming]: '1 / year',
      [WellnessPlanBenefits.UrineFecalTest]: '1 / year',
      [WellnessPlanBenefits.AnalGlandExpression]: '1 / year'
    },
    price: 29.95,
    buttonHref: WagWebAppUrl.WellnessPlatinumFlow
  },
  [WellnessPlanNames.Diamond]: {
    title: WellnessPlanNames.Diamond,
    icon: diamond,
    iconAlt: 'Wag! Wellness Diamond Plan',
    description: 'The ultimate pet care plan. For pets that need frequent attention and visits, with numerous shots, tests, and boosters',
    benefits: {
      [WellnessPlanBenefits.VetChat]: <CheckIcon width="24px" height="24px" color="wagGreen" />,
      [WellnessPlanBenefits.PhysicalExam]: '2 / year',
      [WellnessPlanBenefits.AnnualShotsBoosters]: '9 / year',
      [WellnessPlanBenefits.BloodDiagnosticTest]: '2 / year',
      [WellnessPlanBenefits.Deworming]: '2 / year',
      [WellnessPlanBenefits.UrineFecalTest]: '2 / year',
      [WellnessPlanBenefits.AnalGlandExpression]: '2 / year'
    },
    price: 59.95,
    buttonHref: WagWebAppUrl.WellnessDiamondFlow
  }
};
export const WELLNESS_PLAN_DATA = [WELLNESS_PLANS.Gold, WELLNESS_PLANS.Platinum, WELLNESS_PLANS.Diamond];